const ALL_WIDGETS = [
  {
    name: 'CPU_CONFIG'
  },
  {
    name: 'MEMORY_CONFIG'
  },
  {
    name: 'NET_TRAFFIC'
  },
  {
    name: 'PATCH_STATUS'
  },
  {
    name: 'ANTIVIRUS'
  },
  {
    name: 'FIRE_WALL'
  },

  {
    name: 'DISK_USAGE'
  },
  {
    name: 'ACRONIS'
  },
  {
    name: 'BATTERY'
  },
  {
    name: 'DATA_BACKUP'
  }
];

const ASSET_OFFLINE = 'OFFLINE';
const ASSET_ONLINE = 'ONLINE';

const WINDOWS_WIDGETS = [
  'CPU_CONFIG',
  'MEMORY_CONFIG',
  'PATCH_STATUS',
  'ANTIVIRUS',
  'NET_TRAFFIC',
  'ACRONIS',
  'DISK_USAGE',
  'FIRE_WALL',
  'BATTERY',
  'DATA_BACKUP'
];

const LINUX_WIDGETS = [
  'CPU_CONFIG',
  'MEMORY_CONFIG',
  'PATCH_STATUS',
  'NET_TRAFFIC',
  'DISK_USAGE',
  'BATTERY',
  'DATA_BACKUP'
];

const MAC_WIDGETS = [
  'CPU_CONFIG',
  'MEMORY_CONFIG',
  'NET_TRAFFIC',
  'ACRONIS',
  'DISK_USAGE',
  'FIRE_WALL',
  'PATCH_STATUS',
  'BATTERY',
  'DATA_BACKUP'
];

const CLASS_MAP = {
  1: 'WINDOWS',
  2: 'LINUX',
  3: 'MAC'
};

const WIDGET_MAP = {
  WINDOWS: WINDOWS_WIDGETS,
  LINUX: LINUX_WIDGETS,
  MAC: MAC_WIDGETS
};

const MAC_TABS = [
  'SUMMARY',
  'DETAILS',
  'NETWORK_ASSETS',
  'APPS',
  'IT_DOCUMENTATION',
  'POLICIES',
  'TICKETS',
  'ALERTS',
  'PATCHES',
  'SCRIPTS'
];

const WINDOWS_TABS = [
  'SUMMARY',
  'DETAILS',
  'NETWORK_ASSETS',
  'APPS',
  'IT_DOCUMENTATION',
  'POLICIES',
  'TICKETS',
  'ALERTS',
  'PATCHES',
  'SCRIPTS'
];

const LINUX_TABS = [
  'SUMMARY',
  'DETAILS',
  'NETWORK_ASSETS',
  'APPS',
  'IT_DOCUMENTATION',
  'POLICIES',
  'TICKETS',
  'ALERTS',
  'PATCHES',
  'SCRIPTS'
];

const TAB_MAP = {
  WINDOWS: WINDOWS_TABS,
  LINUX: LINUX_TABS,
  MAC: MAC_TABS
};

const PATCH_APPROVAL_STATUS = {
  PENDING: 'Pending',
  REJECTED: 'Rejected'
};

const PATCH_INSTALL_STATUS = {
  INSTALLED: 'Installed'
};

const imageMap = {
  1: 'svg/windows.svg',
  2: 'svg/linux.svg',
  3: 'svg/mac.svg',
  4: 'svg/printer.png'
};
const PLATFORM_SERVER = 'SERVER';
const PLATFORM_WORKSTATION = 'WORKSTATION';
export {
  ALL_WIDGETS,
  WINDOWS_WIDGETS,
  MAC_WIDGETS,
  CLASS_MAP,
  WIDGET_MAP,
  MAC_TABS,
  WINDOWS_TABS,
  ASSET_OFFLINE,
  ASSET_ONLINE,
  TAB_MAP,
  PATCH_APPROVAL_STATUS,
  PATCH_INSTALL_STATUS,
  imageMap,
  PLATFORM_SERVER,
  PLATFORM_WORKSTATION
};
